import Vue from "vue";
import { filterValueToLabelMapping } from "../helpers.js";

export default {
  getReport({ commit, state }) {
    const payload = {
      ...state.payload,
      page: state.currentPage,
      perPage: state.perPage,
    };
    commit("tableLoading", true);
    return new Promise((resolve, reject) => {
      Vue.$http
        .post(`/organization/reports/employees/fetch`, payload)
        .then(response => {
          let tableHeading = [];
          let formatedData = [];

          if (response.data.results.length > 0) {
            tableHeading = Object.keys(response.data.results[0]).map(x => ({
              value: x,
              label: filterValueToLabelMapping[x],
            }));
            formatedData = response.data.results.map(x => {
              if (!x["status"] === "undefined") return x;
              return {
                ...x,
                status: x["status"] === 1 ? "Active" : "Inactive",
              };
            });
          }

          commit("tableLoading", false);
          commit("employeeReports", formatedData);
          commit("total", response.data.total);
          commit("tableHeading", tableHeading);
          resolve(response);
        })
        .catch(error => {
          commit("tableLoading", false);
          reject(error);
        });
    });
  },

  downloadReport({ commit, state }, format) {
    const payload = {
      ...state.payload,
      page: state.currentPage,
      perPage: state.perPage,
    };
    commit("tableLoading", true);
    return new Promise((resolve, reject) => {
      Vue.$http
        .post(`/organization/reports/employees/download/${format}`, payload)
        .then(response => {
          commit("tableLoading", false);
          resolve(response);
        })
        .catch(error => {
          commit("tableLoading", false);
          reject(error);
        });
    });
  },

  handleSizeChange({ commit, dispatch }, perPage) {
    commit("perPage", perPage);
    dispatch("getReport");
  },

  handleCurrentChange({ commit, dispatch }, page) {
    commit("currentPage", page);
    dispatch("getReport");
  },
};
